import antdKkKZ from 'antd/es/locale/kk_KZ';
import antdRuRU from 'antd/es/locale/ru_RU';
import antdEnUS from 'antd/es/locale/en_US';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import kk from './locales/kk_KZ.json';
import ru from './locales/ru_RU.json';
import en from './locales/en_US.json';

// Фрагменты переводов по зонам (создаются помодульно), сливаются в общие бандлы.
// Ключи плоские с точками-namespace; при коллизии побеждает фрагмент (идёт позже).
import newsRu from './locales/news.ru.json';
import newsKk from './locales/news.kk.json';
import newsEn from './locales/news.en.json';
import teamARu from './locales/teamA.ru.json';
import teamAKk from './locales/teamA.kk.json';
import teamAEn from './locales/teamA.en.json';
import teamBRu from './locales/teamB.ru.json';
import teamBKk from './locales/teamB.kk.json';
import teamBEn from './locales/teamB.en.json';
import dashARu from './locales/dashA.ru.json';
import dashAKk from './locales/dashA.kk.json';
import dashAEn from './locales/dashA.en.json';
import dashBRu from './locales/dashB.ru.json';
import dashBKk from './locales/dashB.kk.json';
import dashBEn from './locales/dashB.en.json';
import lspivRu from './locales/lspiv.ru.json';
import lspivKk from './locales/lspiv.kk.json';
import lspivEn from './locales/lspiv.en.json';
import featuresRu from './locales/features.ru.json';
import featuresKk from './locales/features.kk.json';
import featuresEn from './locales/features.en.json';

import moment from 'moment';
import "moment/locale/ru";
import "moment/locale/kk";
import "moment/locale/en-gb";

const ruAll = { ...ru, ...newsRu, ...teamARu, ...teamBRu, ...dashARu, ...dashBRu, ...lspivRu, ...featuresRu };
const kkAll = { ...kk, ...newsKk, ...teamAKk, ...teamBKk, ...dashAKk, ...dashBKk, ...lspivKk, ...featuresKk };
const enAll = { ...en, ...newsEn, ...teamAEn, ...teamBEn, ...dashAEn, ...dashBEn, ...lspivEn, ...featuresEn };

export const resources = {
    ru: {
        translation: ruAll,
        antd: antdRuRU,
    },
    kk: {
        translation: kkAll,
        antd: antdKkKZ,
    },
    en: {
        translation: enAll,
        antd: antdEnUS,
    },
};

let lan = localStorage.getItem('lan') === "ENG" ? 'en' :
    (localStorage.getItem('lan') === "РУС" ? 'ru' :
        (localStorage.getItem('lan') === "ҚАЗ" ? 'kk' : 'ru'));

const setMomentLocale = (language) => {
    switch (language) {
        case 'kk':
            moment.locale('kk'); // Казахская локализация
            break;
        case 'ru':
            moment.locale('ru'); // Русская локализация
            break;
        case 'en':
        default:
            moment.locale('en'); // Английская локализация (по умолчанию)
            break;
    }
};


i18n.use(initReactI18next).init({
    resources,
    fallbackLng: lan,
    lng: lan,
    interpolation: {
        escapeValue: false,
    },
    detection: {
        order: ['localStorage', 'navigator'],
        caches: ['localStorage'],
    }
});

// Устанавливаем локаль moment.js после инициализации
setMomentLocale(lan);

// Подписка на изменения языка
i18n.on('languageChanged', (lng) => {
    setMomentLocale(lng);
});

export default i18n;
